import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  actionTypes,
  certificationConfigurationsRequestFailure,
  certificationConfigurationsRequestSuccess,
  configurationEnrichmentRequestFailure,
  configurationEnrichmentRequestSuccess,
} from "./actions";
import {
  getConfigurationEnrichment,
  getPaginationTableConfigurations,
} from "./services";

const fetchCertificationConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST),
    mergeMap((action: any) =>
      getPaginationTableConfigurations(action.payload).pipe(
        map((response: any) =>
          certificationConfigurationsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(certificationConfigurationsRequestFailure(error))
        )
      )
    )
  );

const fetchGetConfigurationEnrichmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATION_ENRICHMENT_REQUEST),
    mergeMap((action: any) =>
      getConfigurationEnrichment(action.payload).pipe(
        map((response: any) => configurationEnrichmentRequestSuccess(response)),
        catchError((error: any) =>
          of(configurationEnrichmentRequestFailure(error))
        )
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  fetchCertificationConfigurationsEpic,
  fetchGetConfigurationEnrichmentEpic,
];
